export default __webpack_public_path__ + "static/02_peeker-1aed09c1595f3cfc5467db4b9d203eab.gif";